import type { CreatePropertyInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreatePropertyMutation } from '../hooks/use-property-mutations'
import { PropertyForm } from './property-form'

type PropertyCreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo inmueble" dentro del side panel: el mismo PropertyForm que la edición. */
export function PropertyCreatePanel({ onDone }: PropertyCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreatePropertyMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreatePropertyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <PropertyForm
      submitLabel="Crear inmueble"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
